import { Button } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import Listlet from "../../../components/Listlet/Listlet";
import endpoints from "../../../environment/endpoints";
import FetchService from "../../../services/FetchService";
import { svr_MashList } from "../../../types";
import styles from "./mashlist-view.module.css";

export interface Props {
  id: string;
}

const fetchService = new FetchService();

export default function MashListView(props: Props) {
  const [mashList, setMashList] = useState<svr_MashList>({
    id: "-",
    name: "",
    contenders: [],
  });

  const fetchList = useCallback(() => {
    fetchService
      .get(endpoints.getMashList, props.id)
      .then((res) => (res.success ? setMashList(res.data) : alert(res.errors)));
  }, [props.id]);

  useEffect(() => {
    props.id && fetchList();
  }, [props.id, fetchList]);

  return (
    <div className={styles.container}>
      <div className={styles.cap}>
        <h1 className={styles.h1}>{mashList.name}</h1>
        <Button variant="contained" color="primary" href={`${props.id}/voting-session`}>Get Mashing</Button>
      </div>
      <div className={styles.bottle}>
        <div className={styles.listletContainer}>
          <div className={styles.listletContainerScroll}>
            <ul className={styles.ul}>
              {mashList.contenders.map((c) => (
                <li key={c.id}>
                  <Listlet
                    numerator={c.rank}
                    heading={c.title}
                    description={c.description}
                    imageUrl={c.imageUrl}
                    score={c.score}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
